import DocumentsPage from './DocumentsPage';

export {
    DocumentsPage,
};


// WEBPACK FOOTER //
// src/client/components/site/features/documents/pages/index.js